import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 路由懒加载
const home = (resolve) => {
  import('@/components/home').then((module) => {
    resolve(module)
  })
}


const compStep1 = (resolve) => {
  import('@/components/companyPage/step1').then((module) => {
    resolve(module)
  })
}
const persStep1 = (resolve) => {
  import('@/components/personalPage/step1').then((module) => {
    resolve(module)
  })
}
const finished = (resolve) => {
  import('@/components/finished').then((module) => {
    resolve(module)
  })
}
export default new Router({
      routes: [
          // 首页
          {
            path: '/',
            component: home,
            meta: {
              title: '首页',
              isShowHead: false,
              isShowFoot: true
            },

          },
           {
             path: '/home',
             name: 'home',
             component: home
           },

          {
            path: '/companyPage/step1',
            name: 'compStep1',
            component: compStep1
          },

          {
            path: '/personalPage/step1',
            name: 'persStep1',
            component: persStep1
          },
          {
            path: '/finished',
            name: 'finished',
            component: finished
          },
       ]
  
})



// WEBPACK FOOTER //
// ./src/router/index.js